import React from 'react';
import { withRouter } from 'react-router-dom';
import ChangePasswordForm from '../../forms/ChangePasswordForm';

export class ChangePasswordPage extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">
        <ChangePasswordForm />
      </div>
    );
  }
}

export default withRouter(ChangePasswordPage);


// WEBPACK FOOTER //
// ./src/components/pages/ChangePasswordPage/ChangePasswordPage.jsx